import {AfterContentInit, Component, ContentChildren, OnDestroy, QueryList} from "@angular/core";
import {PropertyItemComponent} from "./property-item.component";
import {Subscription} from "rxjs";
import {ReduceBehaviorSubject} from "../helpers/reduce-behavior-subject";

@Component({
  selector: "property-container",
  templateUrl: "./property-container.template.pug",
})
export class PropertyContainerComponent implements AfterContentInit, OnDestroy {
  private changesSubscription: Subscription;
  private childSubscription: Subscription;
  private childSubject: ReduceBehaviorSubject<PropertyItemComponent, boolean, boolean> =
    new ReduceBehaviorSubject<PropertyItemComponent, boolean, boolean>((p, c) => (p || c), () => false);

  @ContentChildren(PropertyItemComponent)
  propertyItemComponents: QueryList<PropertyItemComponent>;

  show: boolean = false;

  private addComponents() {
    this.propertyItemComponents.forEach((item) => {
      this.childSubject.add(item, item.subject);
    });
  }

  ngAfterContentInit() {
    this.childSubscription = this.childSubject.subscribe((show) => {
      this.show = show;

      let addDot = false;
      this.propertyItemComponents.forEach((item) => {
        if (item.subject.value) {
          if (addDot) {
            item.dot = true;
          } else {
            item.dot = false;
            addDot = true;
          }
        } else {
          item.dot = false;
        }
      });
    });

    this.changesSubscription = this.propertyItemComponents.changes.subscribe(() => {
      this.addComponents();
    });

    this.addComponents();
  }

  ngOnDestroy() {
    if (this.changesSubscription && !this.changesSubscription.closed) {
      this.changesSubscription.unsubscribe();
    }

    if (this.childSubscription && !this.childSubscription.closed) {
      this.childSubscription.unsubscribe();
    }
  }
}
